<template>
  <label class="themed-toggle" :class="{ 'themed-toggle--disabled': disabled }">
    <input
      :id="id"
      type="checkbox"
      role="switch"
      :checked="value"
      @change="handleChange"
      :disabled="disabled"
      :aria-invalid="ariaInvalid"
      :aria-describedby="ariaDescribedby"
      :aria-required="ariaRequired"
      :aria-checked="value ? 'true' : 'false'"
      class="themed-toggle__checkbox"
    >
    <span class="themed-toggle__switch"></span>
    <span v-if="label" class="themed-toggle__label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'ThemedToggle',
  
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaRequired: {
      type: String,
      default: null
    }
  },
  
  methods: {
    handleChange(event) {
      if (!this.disabled) {
        this.$emit('input', event.target.checked);
      }
    }
  }
};
</script>

